import $ from 'zepto'

let loaded = {}
let $body = $('body')

function loadScript (src, attrs) {
  return new Promise((resolve, reject) => {
    if (loaded[src]) {
      return resolve()
    }

    var script = $('<script />')
    script.attr(attrs)
    script.on('load', function () {
      loaded[src] = true
      resolve()
    })
    script.on('error', function (error) {
      reject(error)
    })
    script.attr('src', src)
    script.appendTo($body)
  })
}

export default loadScript


// WEBPACK FOOTER //
// ./src/mods/loadAsset.js